interface FilterPillsProps {
  filters: { label: string; count?: number }[];
  active: string;
  onChange: (label: string) => void;
}

export function FilterPills({ filters, active, onChange }: FilterPillsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1">
      {filters.map(({ label, count }) => {
        const isActive = label === active;
        const text = count != null ? `${label} (${count})` : label;
        return (
          <button
            key={label}
            type="button"
            onClick={() => onChange(label)}
            className={
              isActive
                ? 'px-3 py-1 text-xs lg:px-4 lg:py-1.5 lg:text-sm font-bold bg-white text-td-magenta rounded-full shadow-sm border border-td-magenta/30 whitespace-nowrap'
                : 'px-3 py-1 text-xs lg:px-4 lg:py-1.5 lg:text-sm font-semibold bg-white text-td-muted rounded-full shadow-sm border border-transparent hover:text-td-magenta hover:border-td-magenta/30 transition whitespace-nowrap'
            }
          >
            {text}
          </button>
        );
      })}
    </div>
  );
}
